<!-- Shipping Export Fields Modal -->
<div class="modal fade" id="kt_modal_shipping_export_fields" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-800px">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Select Fields to Export</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
        <!-- Select All Checkbox -->
        <div class="d-flex justify-content-between align-items-center mb-5 pb-3 border-bottom">
          <div class="form-check form-check-custom form-check-solid">
            <input
              class="form-check-input"
              type="checkbox"
              id="selectAllFields"
              [(ngModel)]="selectAll"
              (change)="toggleSelectAll()" />
            <label class="form-check-label fw-bold fs-5" for="selectAllFields">
              Select All Fields
            </label>
          </div>
          <span class="badge badge-light-primary fs-6">
            {{ getSelectedCount() }} of {{ availableFields.length }} selected
          </span>
        </div>

        <!-- Fields Grid -->
        <div class="row g-3">
          <div class="col-md-6" *ngFor="let field of availableFields; let i = index">
            <div class="form-check form-check-custom form-check-solid">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'field_' + i"
                [(ngModel)]="field.selected"
                (change)="onFieldToggle()" />
              <label class="form-check-label" [for]="'field_' + i">
                {{ field.label }}
              </label>
            </div>
          </div>
        </div>

        <!-- Warning Message -->
        <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed p-4 mt-5" *ngIf="getSelectedCount() === 0">
          <i class="ki-duotone ki-information fs-2tx text-warning me-4">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-semibold">
              <div class="fs-6 text-gray-700">Please select at least one field to export.</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onGenerateExcel()"
          [disabled]="getSelectedCount() === 0">
          <i class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Generate Excel
        </button>
      </div>
    </div>
  </div>
</div>
